import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import SearchBarsRegularAi from './search-bars-regular-ai-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <SearchBarsRegularAi {...validProps} />;
}
SvgComponent.iconName = 'searchBarsRegularAi';

export const SearchBarsRegularAiIcon = svgIconWrapper(SvgComponent);
